export const SAVE_JOBS_LIST = 'SAVE_JOBS_LIST'; 
export const SAVE_JOB_DETAILS = 'SAVE_JOB_DETAILS'; 